<!--前台首页-->
<template>
    <div class="reception-module">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="operation-box flex-row flex-around">
                <!-- <div class="operation-list flex-col" @click="toDisinfect()" v-if="postId!='1472787652026765362'">
                    <img class="operation-img" referrerpolicy="no-referrer" alt=""
                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/disinfection.png" />
                    <span class="operation-title">消杀</span>
                </div> -->
                <div class="operation-list flex-col" @click="toMyScheduling()">
                    <img class="operation-img" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/rostering.png" />
                    <span class="operation-title">排班</span>
                </div>
                <div class="operation-list flex-col" @click="toBookingToStore()">
                    <img class="operation-img" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/receptionAppointment.png" />
                    <span class="operation-title">预约</span>
                </div>
            </div>
            <!-- <div class="todayData-box  flex-row">
                <img class="todayData-img" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/todaydata.png" />
                <div class="todayData-title">今日数据</div>
            </div>
            <div class="todayData-list flex-y-center">
                <div class="todayData-list-first-box flex-col" @click="toNewCustomer()">
                    <div class="todayData-list-title">新客量</div>
                    <div class="flex">
                        <div class="todayData-detail-contens">
                            <div class="todayData-number">{{dataDayDTO.newClient}}</div>
                            <div class="unit">人</div>
                        </div>
                    </div>
                </div>
                <div class="todayData-list-box flex-col" @click="toNewCardList()">
                    <div class="todayData-list-title">新办卡</div>
                    <div class="flex">
                        <div class="todayData-detail-contens">
                            <span class="todayData-number">{{dataDayDTO.cardSum}}</span>
                            <span class="unit">张</span>
                        </div>
                    </div>
                </div>
                <div class="todayData-list-box  flex-col" @click="toPassengerFlow()">
                    <div class="todayData-list-title">客流量</div>
                    <div class="flex">
                        <div class="todayData-detail-contens">
                            <div class="todayData-number">{{dataDayDTO.flowSum}}</div>
                            <div class="unit">人</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="table">
                <div class="table-tab flex  ">
                    <div :class="`tab-item ml ${tabIndex == 0 ? 'active' : ''}`" @click="clickTab(0)">
                        今日未来店
                    </div>
                    <div :class="`tab-item  item-text ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">
                        今日已来店
                    </div>
                </div>
                <div class="box-line"></div>
                <div class="list-box">
                    <!-- 下拉刷新 -->
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getCustomerList" :offset="20" :immediate-check="false">
                        <div v-for="(item, index) in customerList" :key="index" class="customer-list flex-col" @click="toDetail(item.custId, item.custMobile)">
                            <div class="flex-row">
                                <img class="customer-head-portrait" referrerpolicy="no-referrer" alt="" :src="item.avatar ? item.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                                <div class="customer-info flex-1">
                                    <div class="flex-y-center">
                                        <div class="customer-name">{{ item.custName }}
                                        </div>
                                        <div class="customer-phone">{{ item.custMobile }}</div>
                                    </div>
                                    <div class="churn-time">预约时间：{{ item.beginTime }}</div>
                                </div>
                                <img class="arrow_right" referrerpolicy="no-referrer" alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                            </div>
                            <div class="customer-remark flex-between flex-y-center">
                                <div class="flex-between flex-y-center">
                                    <span class="sale-name">专属：</span>
                                    <span class="sale-number">{{ item.empName }}</span>
                                </div>
                                <div class="flex-between flex-y-center">
                                    <span class="sale-name">预约美疗师：</span>
                                    <span class="sale-number">{{ item.name }}</span>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
            </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { getCookie } from '@/utils';


    export default {
        data() {
            return {
                masterData: [],  //首页数据
                dataDayDTO: [],  //今日数据
                bulletin: [],    //本月简报
                tabIndex: 0, // tab栏下标
                customerList: [],//到店信息
                loading: false,    //加载
                finished: false,    //结束加载
                refreshing: false,   //刷新
                postId: '',   //岗位ID

            };
        },
        mounted() {
            // this.onLoad();
            this.getCustomerList();
            this.postId = getCookie('postId') || localStorage.getItem('postId');
        },
        methods: {
            //今日数据加载
            // onLoad() {
            //     request({
            //         url: '/home/index',
            //         method: "get",
            //     })
            //         .then((res) => {
            //             this.masterData = res.data;
            //             this.dataDayDTO = res.data.dataDayDTO;
            //             this.bulletin = res.data.bulletin;
            //         }).catch((error) => {
            //             Toast({ position: 'top', message: error ?? '' })
            //         }).finally(() => {
            //         });
            // },
            //刷新
            onRefresh() {
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.refreshing = false;
                // this.onLoad();
                this.getCustomerList();
            },
            //跳转消杀页面
            toDisinfect() {
                this.$router.push({ name: 'disinfect', query: {}, });
            },
            //跳转排班页面
            toMyScheduling() {
                this.$router.push({ name: 'myScheduling', query: {}, });
            },

            //跳转预约页面
            toBookingToStore() {
                this.$router.push({ name: "bookingToStore", query: {} });
            },

            //跳转新增客户列表
            toNewCustomer() {
                this.$router.push({ name: 'newCustomersList', query: {}, });
            },
            //跳转客流列表
            toPassengerFlow() {
                this.$router.push({ name: 'passengerFlowList', query: {}, });
            },

            //跳转新办卡详情
            toNewCardList() {
                this.$router.push({ name: "newCardList", query: {} });
            },
            // tab切换
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                this.getCustomerList();
            },
            //查看顾客详情
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },

            //到店列表
            getCustomerList() {
                this.loading = true
                request({
                    url: "/home/getList?type=" + this.tabIndex,
                    method: "get",
                })
                    .then((res) => {
                        this.customerList = res.data;
                        this.page += 1;
                        this.finished = true;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                    });
            },
        },
    }
</script>


<style scoped lang="less">
    .reception-module {
        // height: 80vh;
        // overflow-y: auto;
    }

    .operation-box {
        height: 125px;
        justify-content: space-evenly;

        .operation-list {
            // margin-right: 145px;
        }

        .operation-img {
            width: 80px;
            height: 80px;
        }

        .operation-title {
            overflow-wrap: break-word;
            color: rgba(53, 67, 76, 1);
            font-size: 28px;
            text-align: left;
            white-space: nowrap;
            line-height: 40px;
            align-self: center;
            margin-top: 5px;
        }
    }

    .remind-box {
        height: 80px;
        background-color: rgba(250, 250, 254, 1);
    }

    .remind-content {
        margin: 0 0 0 30px;
    }

    .remind-time {
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        line-height: 37px;
        margin-right: 30px;
    }

    .remind-type {
        color: rgba(246, 82, 82, 1);
        font-size: 26px;
        line-height: 37px;
    }

    .remind-text {
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        line-height: 37px;
    }

    .todayData-img {
        width: 40px;
        height: 40px;
        display: block;
        margin-top: 54px;
    }

    .todayData-box {
        margin-left: 30px;
    }

    .todayData-title {
        color: rgba(53, 67, 76, 1);
        font-size: 34px;
        text-align: left;
        margin: 50px 0 0 10px;
        font-weight: 700;
    }

    .todayData-list {
        margin-top: 42px;
    }

    .todayData-list-first-box {
        width: 200px;
        height: 155px;
        background: #fafafe;
        border-radius: 30px;
        margin-left: 30px;
    }

    .todayData-list-box {
        width: 200px;
        height: 155px;
        background: #fafafe;
        border-radius: 30px;
        margin-left: 45px;
    }

    .todayData-list-title {
        color: rgba(160, 172, 181, 1);
        font-size: 28px;
        text-align: center;
        margin-top: 20px;
    }

    .unit {
        color: rgba(53, 67, 76, 1);
        font-size: 26px;
        display: flex;
        align-items: flex-end;
        padding-left: 10px;
        padding-bottom: 8px;
    }

    .todayData-list-contens {
        display: flex;
    }

    .todayData-detail-contens {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .todayData-number {
        color: rgba(53, 67, 76, 1);
        font-size: 46px;
        font-weight: 700;
    }

    .briefing-list-first {
        width: 330px;
        height: 200px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px solid #d8d8d8;
        margin: 40px 0 0 30px;
    }

    .briefing-list-second {
        width: 330px;
        height: 200px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px solid #d8d8d8;
        margin: 20px 0 0 30px;
    }

    .list-box {
        width: 100%;
        // height: 50vh;
        margin-top: 40px;
        // overflow-y: auto;
        padding: 0 30px 250px 30px;

        .customer-list {
            width: 690px;
            height: 200px;
            background: #fafafe;
            border-radius: 20px;
            margin-bottom: 20px;
            padding: 20px;
        }

        .customer-head-portrait {
            width: 90px;
            height: 90px;
            border-radius: 45px;
            margin-right: 20px;
        }

        .customer-name {
            min-width: 60px;
            height: 42px;
            font-size: 30px;
            color: #35434c;
            line-height: 42px;
            font-weight: 700;
        }

        .customer-phone {
            min-width: 60px;
            height: 42px;
            font-size: 30px;
            color: #35434c;
            line-height: 42px;
            // margin: 20px 0 0 20px;
            margin-left: 20px;
        }

        .churn-time {
            // height: 37px;
            // font-size: 26px;
            // color: #a0acb5;
            // line-height: 37px;
            // margin-top: 11px;
            height: 37px;
            font-size: 26px;
            color: #a0acb5;
            line-height: 37px;
            margin-top: 11px;
        }

        .arrow_box {
            margin: -10px 30px 0 auto;
        }

        .arrow_right {
            width: 15px;
            height: 26px;
            margin-top: 10px;
        }

        .exclusive {
            min-width: 84px;
            height: 40px;
            font-size: 28px;
            color: #a0acb5;
            line-height: 40px;
            margin: 30px 0 0 20px;
        }

        .exclusive-name {
            min-width: 84px;
            height: 40px;
            font-size: 28px;
            color: #35434c;
            line-height: 40px;
            margin-top: 30px;
            font-weight: 700;
        }

        .loss {
            min-width: 140px;
            height: 40px;
            font-size: 28px;
            color: #a0acb5;
            line-height: 40px;
            margin: 30px 0 0 84px;
        }

        .loss-reasons {
            height: 40px;
            font-size: 28px;
            color: #35434c;
            line-height: 40px;
            margin-top: 30px;
            font-weight: 700;
        }

        .customer-remark {
            margin: 0 160px 0 0;
        }

        .sale-number {
            height: 45px;
            font-size: 28px;
            color: #35434c;
            line-height: 45px;
            margin-top: 28px;
            min-width: 40px;
            font-weight: 700;
        }

        .sale-name {
            height: 40px;
            font-size: 28px;
            color: #a0acb5;
            line-height: 40px;
            margin-top: 30px;
        }
    }

    .ml {
        margin-left: 30px;
    }

    .table {
        .table-tab {
            width: 100%;
            height: 100%;
            display: flex;
            margin: 50px 0 0 0px;
        }

        .tab-item {
            // width: 150px;
            height: 42px;
            font-size: 30px;
            font-weight: 400;
            color: #a0acb5;
            // text-align: center;
            position: relative;
        }

        .item-text {
            margin-left: 50px;
        }

        .tab-item.active {
            color: #35434c;
            font-weight: bold;
        }

        .tab-item.active::after {
            position: absolute;
            bottom: -10px;
            content: "";
            left: 50%;
            transform: translateX(-50%);
            width: 50px;
            height: 8px;
            background: #2fd0d5;
            border-radius: 4px;
        }

        .box-line {
            // width: 690px;
            // height: 1px;
            background: #d7d7d7;
            margin: 10px 0 0 30px;
        }
    }

    :deep(.van-icon-arrow) {
        font-size: 15px !important;
        margin: 13px 0 9px 10px !important;
        color: #4d5961 !important;
    }
</style>
